module.exports = __webpack_public_path__ + "img/9.ac238443.png";